<template>
  <div>
    <material-button
      class="d-none"
      data-bs-toggle="modal"
      data-bs-target="#modalUpsellItemBranches"
      id="show-modal-upsell-item-branches"
    ></material-button>
    <material-button
      class="d-none"
      data-bs-dismiss="modal"
      data-bs-target="#modalUpsellItemBranches"
      id="hide-modal-upsell-item-branches"
    ></material-button>

    <div
      class="modal fade"
      id="modalUpsellItemBranches"
      tabindex="-1"
      aria-hidden="true"
      style="z-index: 1056"
    >
      <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">Branches</h5>
            <i
              style="cursor: pointer"
              class="material-icons btn-close-modal justify-content-end"
              data-bs-dismiss="modal"
              aria-label="Close"
              >clear</i
            >
          </div>

          <div class="modal-body">
            <div class="w-100 mb-3">
              <label class="fw-bold mb-1" for="">Upsell item</label>
              <div class="source-pill">{{ itemName }}</div>
            </div>

            <div class="w-100 mb-3">
              <label class="fw-bold mb-1" for="">Show this item at</label>
              <div class="form-check mb-1">
                <input
                  class="form-check-input"
                  type="radio"
                  id="upsellBranchScopeAll"
                  :checked="isAllBranches"
                  @change="setScope(true)"
                />
                <label class="form-check-label" for="upsellBranchScopeAll">
                  All branches using this menu set
                </label>
              </div>
              <div class="form-check">
                <input
                  class="form-check-input"
                  type="radio"
                  id="upsellBranchScopeSelected"
                  :checked="!isAllBranches"
                  @change="setScope(false)"
                />
                <label class="form-check-label" for="upsellBranchScopeSelected">
                  Selected branches only
                </label>
              </div>
            </div>

            <div class="w-100 mb-1" v-if="!isAllBranches">
              <label class="fw-bold" for="">Branches</label>
              <Multiselect
                v-model="selectedBranchIds"
                mode="tags"
                :close-on-select="false"
                :searchable="true"
                :options="branchOptions"
                placeholder="Select branches"
                :canClear="true"
              />
              <div class="w-100 mt-1">
                <span class="is-invalid" v-if="isBranchRequired"
                  >Select at least one branch.</span
                >
              </div>
            </div>

            <div class="w-100 mt-3" v-if="!isAllBranches && selectedBranchIds.length">
              <label class="fw-bold mb-1" for="">Price per branch</label>
              <div class="text-xs text-secondary mb-2">
                Leave a branch empty to charge the item price
                ({{ defaultPriceFormat }}).
              </div>
              <div class="branch-price-list">
                <div
                  class="d-flex align-items-center justify-content-between branch-price-row"
                  v-for="branchId in selectedBranchIds"
                  :key="branchId"
                >
                  <span class="branch-price-name">{{ branchLabel(branchId) }}</span>
                  <div class="d-flex align-items-center branch-price-input">
                    <span class="me-1">$</span>
                    <input
                      type="number"
                      min="0"
                      step="0.01"
                      class="form-control form-control-sm"
                      :placeholder="defaultPriceNumber"
                      v-model="branchPrices[branchId]"
                    />
                  </div>
                </div>
              </div>
            </div>

            <div class="d-flex justify-content-end mt-4">
              <material-button
                class="mx-2 btn btn-sm btn-background"
                @click="save()"
              >
                Save
              </material-button>
              <material-button
                class="mx-2 btn btn-sm btn-background"
                data-bs-dismiss="modal"
                aria-label="Close"
              >
                Cancel
              </material-button>
            </div>
          </div>
        </div>
      </div>
      <material-loading :active="loaderActive" />
    </div>

    <div class="position-fixed top-1 end-1 z-index-9999 message-success">
      <material-snackbar
        v-if="snackbar === 'danger' || snackbar === 'success'"
        title=""
        date=""
        :description="message"
        :icon="{ component: 'campaign', color: 'white' }"
        :color="snackbar"
        :close-handler="closeSnackbar"
      />
    </div>
  </div>
</template>
<script>
import MaterialButton from "@/components/MaterialButton.vue";
import MaterialLoading from "@/components/MaterialLoading.vue";
import MaterialSnackbar from "@/components/MaterialSnackbar.vue";
import Multiselect from "@vueform/multiselect";
import "@vueform/multiselect/themes/default.css";
import MenusetService from "../services/product/menuset.service";
import $ from "jquery";

/**
 * SF275 — pick which branches an upsell item is offered at, and what each charges.
 *
 * One menu set is shared by many branches, so until now every branch was forced to advertise the
 * same add-ons. "All branches" stays the default: an item nobody has narrowed behaves exactly as
 * it did before.
 */
export default {
  name: "modal-upsell-item-branches",
  components: {
    MaterialLoading,
    MaterialSnackbar,
    MaterialButton,
    Multiselect,
  },
  props: {
    setId: {
      type: Number,
      required: true,
    },
    // The upsell row from get-settings: carries item, is_all_branches and branch_list.
    upsellItem: {
      type: Object,
      default: null,
    },
    // [{ value: branchId, label: branchName }] — the branches on this menu set.
    branchOptions: {
      type: Array,
      default: () => [],
    },
    keyReload: {
      type: [String, Number],
      required: true,
    },
  },
  data() {
    return {
      snackbar: null,
      message: "",
      loaderActive: false,
      isAllBranches: true,
      selectedBranchIds: [],
      // { [branchId]: price } — a blank entry means "charge the item price".
      branchPrices: {},
      isBranchRequired: false,
    };
  },
  computed: {
    itemName() {
      return this.upsellItem?.item?.item_name || "";
    },
    defaultPriceNumber() {
      const price = parseFloat(this.upsellItem?.item_price);
      return isNaN(price) ? "0.00" : price.toFixed(2);
    },
    defaultPriceFormat() {
      return "$" + this.defaultPriceNumber;
    },
  },
  watch: {
    keyReload() {
      this.hydrate();
    },
  },
  created() {
    this.hydrate();
  },
  methods: {
    // Re-read the row every time the modal is opened; the merchant may have cancelled last time.
    hydrate() {
      this.isBranchRequired = false;
      this.snackbar = null;

      const item = this.upsellItem;
      if (!item) {
        this.isAllBranches = true;
        this.selectedBranchIds = [];
        this.branchPrices = {};
        return;
      }

      this.isAllBranches = item.is_all_branches !== false;
      this.selectedBranchIds = (item.branch_list || []).map((row) => row.branch_id);

      const prices = {};
      (item.branch_list || []).forEach((row) => {
        // A null branch price means "no override" — leave the box empty rather than
        // stamping the item price into it, or saving would turn a fallback into an override.
        prices[row.branch_id] = row.item_price === null ? "" : row.item_price;
      });
      this.branchPrices = prices;
    },

    setScope(isAll) {
      this.isAllBranches = isAll;
      this.isBranchRequired = false;
    },

    branchLabel(branchId) {
      const option = this.branchOptions.find((row) => row.value === branchId);
      return option ? option.label : "";
    },

    save() {
      if (!this.isAllBranches && !this.selectedBranchIds.length) {
        this.isBranchRequired = true;
        return;
      }

      const dataForm = {
        set_id: this.setId,
        item_id: this.upsellItem?.item?.id,
        is_all_branches: this.isAllBranches,
        branches: this.isAllBranches
          ? []
          : this.selectedBranchIds.map((branchId) => {
              const price = this.branchPrices[branchId];
              return {
                branch_id: branchId,
                item_price:
                  price === "" || price === null || price === undefined
                    ? null
                    : price,
              };
            }),
      };

      this.showLoader();
      MenusetService.updateUpsellItemBranches(dataForm).then(
        (response) => {
          this.hideLoader();

          if (response.data.result.isSuccess) {
            $("#hide-modal-upsell-item-branches").click();
            this.$emit("reload-upsell-items", "Update branches success");
          } else {
            this.snackbar = "danger";
            this.message = response.data.result.message;
            this.setTimeOutNotification();
          }
        },
        (error) => {
          this.hideLoader();
          this.snackbar = "danger";
          this.message = error;
          this.setTimeOutNotification();
        }
      );
    },

    showLoader() {
      this.loaderActive = true;
    },

    hideLoader() {
      this.loaderActive = false;
    },

    setTimeOutNotification() {
      setTimeout(() => {
        this.snackbar = null;
      }, 3000);
    },

    closeSnackbar() {
      this.snackbar = null;
    },
  },
};
</script>
<style scoped>
.source-pill {
  display: inline-flex;
  align-items: center;
  padding: 4px 12px;
  border-radius: 16px;
  background-color: #f0f2f5;
  font-size: 0.875rem;
}

.branch-price-list {
  max-height: 220px;
  overflow-y: auto;
}

.branch-price-row {
  padding: 6px 0;
  border-bottom: 1px solid #f0f2f5;
}

.branch-price-row:last-child {
  border-bottom: none;
}

.branch-price-name {
  font-size: 0.875rem;
  padding-right: 12px;
}

.branch-price-input {
  width: 120px;
}

.branch-price-input .form-control {
  text-align: right;
}
</style>
